import React, { useEffect, useState } from "react";
import { Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Requests from "../pages/services/Requests";

function LatestAppointment() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const columns = [
    {
      title: "#",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Service",
      dataIndex: "service",
      sorter: (a, b) => a.service.localeCompare(b.service),
    },
    {
      title: "TelePhone",
      dataIndex: "phone",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "App Date",
      dataIndex: "time",
      render: (text, record) => (
        <>
          <div>{record.date}</div>
          <div className="text-muted small">{text}</div>
        </>
      ),
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <span className={`badge badge-${text === 'Completed' ? 'success' : 'warning'}`}>
          {text}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await Requests.getDashboardStats();

        if (response.data.success && response.data.data.latest_appointments) {
          setData(response.data.data.latest_appointments);
        }
      } catch (err) {
        console.error("Error fetching dashboard stats:", err);
        setError("Failed to load latest appointments");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5 text-danger">
        {error}
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card card-table">
          <div className="card-header">
            <h4 className="card-title">Latest Appointments</h4>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <Table
                style={{ overflowX: "auto" }}
                columns={columns}
                dataSource={data.map((item) => ({ ...item, key: item.id }))}
                pagination={false}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LatestAppointment;